import {ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {StateService} from "../../../core/services/state.service";
import {BaseComponent} from "common-shared";
import {takeUntil} from "rxjs/operators";
import {ConfirmationDialogComponent} from "common-shared";
import {LeModalService} from "common-shared";

@Component({
  selector: 'mes-web-edit-modal-buttons',
  templateUrl: './edit-modal-buttons.component.html',
  styles: [],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class EditModalButtonsComponent extends BaseComponent implements OnInit {
  @Input() entityId: string;
  @Input() hasDeleteButton: boolean;
  @Input() hasForceSaveButton = false;
  @Input() isPristine = true;
  @Input() displayName: string;
  @Input() insideFooter: boolean = true;
  @Input() requiredPrivileges: string[] = [];
  @Output() deleteClick = new EventEmitter<boolean>();
  @Output() saveClick = new EventEmitter<boolean>();
  @Output() forceSaveClick = new EventEmitter<boolean>();
  @Output() addClick = new EventEmitter<boolean>();
  @Output() cancelClick = new EventEmitter<boolean>();

  constructor(public stateService: StateService, private modalService: LeModalService) {
    super();
  }

  ngOnInit(): void {
  }

  deleteClicked() {
    const modalRef = this.modalService.show(ConfirmationDialogComponent, {
      initialState: {
        description: `Delete ${this.displayName ?? 'this entry'}?`,
        options: {hasSafetyCheck: true}
      },
      class: 'modal-sm'
    });
    modalRef.onHide$.pipe(takeUntil(this.componentDestroyed)).subscribe(confirmation => {
      if (confirmation.data) {
        this.deleteClick.emit();
      }
    });
  }
}
